module.exports = __webpack_public_path__ + "img/00-images-date.8252140a.png";